import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Фиды

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export const eventFeedClick = (): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Фид|Подробнее|Клик по кнопке',
  eventLabel: 'Подробнее',
  eventValue: undefined,
});

export const eventFeedDecline = ({
  calcId,
  productId,
  organizationId,
  bankName,
  productName,
}: {
  calcId: string;
  productId: string;
  organizationId: string;
  bankName: string;
  productName: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Шаг 5|Заявка отклонена',
  eventLabel: `${calcId} | ${productId} | ${organizationId} | ${bankName} | ${productName} | Яндекс фид`,
  eventValue: undefined,
});

export const eventFeedSuccess = ({
  calcId,
  productId,
  organizationId,
  bankName,
  productName,
}: {
  calcId: string;
  productId: string;
  organizationId: string;
  bankName: string;
  productName: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Шаг 5|Заявка отправлена',
  eventLabel: `${calcId} | ${productId} | ${organizationId} | ${bankName} | ${productName} | Яндекс фид`,
  eventValue: undefined,
});

export const eventFeedFinishClick = (eventAction: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: `Фид|${eventAction}|Клик по кнопке`,
  eventLabel: 'Подобрать другой кредит',
  eventValue: undefined,
});
